import React from "react";
import JobCard from "../Pages/searchPage/components/card/JobCard";

/**
 *
 * @param text
 * @returns {*}
 */
export function onlyNumbers(text) {
    return text.replace(/\D/g, "");
}

/**
 *
 * @param interval
 * @returns {boolean}
 */
export const isContainOption = (options, interval) => {
    for (let i = 0; i < options.length; i += 1) {
        if (options[i].interval === interval) {
            return true;
        }
    }
};

/**
 * @param interval
 * @returns {*}
 */
export const calcPrice = (options, interval) => {
    let resArray = [];

    for (let i = 0; i < options.length; i += 1) {
        if (options[i].interval === interval) {
            break;
        }
        resArray.push(parseInt(options[i].price));
    }

    return resArray.reduce((a, b) => a + b, 0);
};

/**
 * Collection of field components mapped to types of fields.
 * Enables the variable selection of components based on a keyword.
 * @type {PostTypeMap}
 */
export const PostTypeMap = {
    'recruitee-offer': ({index, result, total, wishlist}) => <JobCard index={index} result={result} total={total}
                                                                wishlist={wishlist}/>,
};
